import {
  type schemaType,
  type paramsType,
  type returnType,
} from '~~/shared/api/rurality/v3/cottage-reviews/cottage/detail/schema'
import {
  serverFetchWrapper,
  browserFetchWrapper,
} from '~~/server/utils/rurality/v3/endpointWrapper'

const endpoint = '/cottage-reviews/cottage/detail'

export const serverFetch = (params: paramsType): Promise<returnType> =>
  serverFetchWrapper<paramsType, schemaType>(endpoint, params)

export const browserFetch = (params: paramsType): Promise<returnType> =>
  browserFetchWrapper<paramsType, schemaType>(endpoint, params)
